import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalResponsible } from '@/types/vehicle-withdrawal-responsible'
import { AxiosResponse } from 'axios'

export function updateVehicleWithdrawalResponsible(
  body: Partial<VehicleWithdrawalResponsible>
): Promise<AxiosResponse<VehicleWithdrawalResponsible>> {
  return instance.put(`/vehicle-withdrawal-responsible/${body.uuid}`, body)
}
